// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "rescript/lib/es6/curry.js";
import * as React from "react";
import * as Belt_List from "rescript/lib/es6/belt_List.js";
import * as PilotQuestionVisible$LiteracyplanetTupperware from "../v3/PilotQuestionVisible.res.mjs";
import * as TupperwareLayoutSwitch$LiteracyplanetTupperware from "../v3/TupperwareLayoutSwitch.res.mjs";
import * as BehaviourQuestionVisible$LiteracyplanetTupperware from "./BehaviourQuestionVisible.res.mjs";
import * as BehaviourMultiChoiceContainer$LiteracyplanetTupperware from "./BehaviourMultiChoiceContainer.res.mjs";

function V2MultiChoiceContainer(props) {
  var children = props.children;
  var __showCorrectAnswerBehaviour = props.showCorrectAnswerBehaviour;
  var questionIndex = props.questionIndex;
  var __fuzzyMark = props.fuzzyMark;
  var fuzzyMark = __fuzzyMark !== undefined ? __fuzzyMark : false;
  var showCorrectAnswerBehaviour = __showCorrectAnswerBehaviour !== undefined ? __showCorrectAnswerBehaviour : false;
  var layout = Curry._1(TupperwareLayoutSwitch$LiteracyplanetTupperware.use, undefined) === "Pilot";
  var answer = Belt_List.fromArray(props.correctAnswer);
  return React.createElement(BehaviourMultiChoiceContainer$LiteracyplanetTupperware.make, {
              correctAnswer: answer,
              fuzzyMark: fuzzyMark,
              questionIndex: questionIndex,
              showCorrectAnswerBehaviour: showCorrectAnswerBehaviour,
              children: layout ? React.createElement(PilotQuestionVisible$LiteracyplanetTupperware.make, {
                      questionIndex: questionIndex,
                      children: children
                    }) : React.createElement(BehaviourQuestionVisible$LiteracyplanetTupperware.make, {
                      questionIndex: questionIndex,
                      children: children
                    })
            });
}

var make = V2MultiChoiceContainer;

var $$default = V2MultiChoiceContainer;

export {
  make ,
  $$default as default,
}
/* react Not a pure module */
